let prefix = '/api/sap/items-warehouses';
function stock(data){
    return window.axios.get(prefix+'/StockWhs',{params: data});
}
export default {
    stock
}